<template>
    <div class="indexbPage">
        <div class="menubox">
            <div class="logo"></div>
            <div class="ulbox">
                <div class="item" @click="toPage('.page1')">售价</div>
                <div class="item" @click="toPage('.page2')">极致性能</div>
                <div class="item" @click="toPage('.page3')">赛车型格</div>
                <div class="item" @click="toPage('.page4')">运动内饰</div>
                <div class="item" @click="toPage('.page5')">匠心定制</div>
                <div class="item" @click="toPage('.page6')">甄选图集</div>
                <div class="item" @click="toPage('.page7')">经销商</div>
            </div>
            <div class="btn-yuyue" @click="showTestDriver">即刻预定</div>
        </div>
        <div class="page page0">
            <div class="bg"></div>
            <div class="logo"></div>
            <img class="gif" src="../assets/gif/gif0.gif" @click="showVideoDialog()" />
            <div class="number-box">
                <div class="num_box">
                    <div class="num">00</div>
                </div>
                <div class="num_c">中国限量<span class="en">66</span>台<br />超限量稀有身份</div>
            </div>
            <div class="txt txt0">Tribute</div>
            <div class="txt txt1">to the Legend</div>
            <div class="txt txt2">我们无法穿透时光 但可以穿越历史</div>
            <div class="txt txt3">致敬传奇赛车 <span class="en">90 quattro IMSA GTO</span>，打破传统，方可成为传奇</div>
            <div class="txt txt4">传奇无法复刻 但燃情可以永存</div>
            <div class="txt txt5">从赛道到公路，<span class="en">V8</span> 引擎牵引梦想，百公里加速极致 <span class="en">3.3</span> 秒，燃油的激情从未让人失望</div>
            <div class="txt txt6"><span class="enb">The Undying Fire</span></div>
            <div class="txt txt7"><span class="enb">of Devotion</span></div>
            <div class="txt txt8"><span class="enb">Peak</span></div>
            <div class="txt txt9"><span class="enb">Performance Redefined</span></div>
            <div class="txt txt10">终极限量 惟极致无可限量</div>
            <div class="txt txt11">与“传奇超跑”奥迪 <span class="en">R8</span> 同厂装配，超跑团队手工定制，诠释卓越工艺与极致性能</div>
        </div>
        <div class="page page1">
            <div class="bg"></div> 
            <div class="price-box">
                <div class="price">1,906,600</div>
                <div class="texts">
                    <div class="txt0">市场指导价</div>
                    <div class="txt1">RMB</div>
                </div>
            </div>
            <!-- <div class="btn-dealer" @click="toDealerUrl()">查看经销商</div> -->
        </div>
        <div class="page page2">
            <div class="bg"></div>
            <div class="textbox">
                <div class="item item0">
                    <div class="numbox">
                        <span class="num">463</span>
                        <span class="dw">kW</span>
                    </div>
                    <div class="label">最大功率</div>
                </div>
                <div class="item item1">
                    <div class="numbox">
                        <span class="num">850</span>
                        <span class="dw">N·m </span>
                    </div>
                    <div class="label">最大扭矩</div>
                </div>
                <div class="item item2">
                    <div class="numbox">
                        <span class="num">3.3</span>
                        <span class="dw">s</span>
                    </div>
                    <div class="label">百公里加速仅需</div>
                </div>
            </div>
        </div>
        <div class="page page3">
            <div class="bg0"></div>
            <div class="bg1"></div>
            <div class="textbox textbox0">
                <div class="txt0">
                    <span class="enb">SINCE 1989<br />90 quattro IMSA GTO</span>
                </div>
                <div class="txt1">传奇赛车 燃情时代</div>
            </div>
            <div class="textbox textbox1">
                <div class="txt0">
                    <span class="enb"><br />RS6 Avant GT</span>
                </div>
                <div class="txt1">锋芒觉醒 传奇再续</div>
            </div>
        </div>
        <div class="page page4">
            <div class="bg"></div>
            <div class="redbg"></div>
            <div class="leftcon">
                <div class="imgbox" style="display: block">
                    <img src="../assets/indexb/page4_img0.jpg" />
                </div>
                <div class="imgbox">
                    <img src="../assets/indexb/page4_img1.jpg" />
                </div>
                <div class="imgbox">
                    <img src="../assets/indexb/page4_img2.jpg" />
                </div>
                <div class="imgbox">
                    <img src="../assets/indexb/page4_img3.jpg" />
                </div>
            </div>
            <div class="rightcon">
                <div class="itembox" @mouseleave="onLeavePage4Item()">
                    <div @mouseenter="onEnterPage4Item(0)" class="item item0">
                        <div class="txt">巅峰性能<br />媲美赛级表现</div>
                        <div class="add" @click="showSwiperBox(0, $event)"></div>
                    </div>
                    <div @mouseenter="onEnterPage4Item(1)" class="item item1">
                        <div class="txt">赛车型格<br />传承经典设计</div>
                        <div class="add" @click="showSwiperBox(1, $event)"></div>
                    </div>
                    <div @mouseenter="onEnterPage4Item(2)" class="item item2">
                        <div class="txt">兼具豪华与运动的内饰</div>
                        <div class="add" @click="showSwiperBox(2, $event)"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page page5">
            <div class="bg"></div>
            <div class="textbox">
                <div class="txt0">超跑团队“手工”定制</div>
                <div class="txt1">
                    与“传奇超跑”奥迪 R8 同厂装配，共享卓越工艺与极致性能，匠心定制，专<br />
                    属部件均由手工精心装配，奥迪品牌致敬工匠精神，以专属定制诠释豪华新境
                </div>
            </div>
        </div>

        <div class="page page6">
            <div class="image-grid">
                <div class="cell cell-0">
                    <div class="img0box">
                        <img src="../assets/indexb/page6_img0.jpg" idx="0" />
                    </div>
                    <div class="img1box">
                        <img src="../assets/indexb/page6_img1.jpg" idx="7" />
                    </div>
                </div>
                <div class="cell cell-1">
                    <div class="row0">
                        <div class="img0box">
                            <img src="../assets/indexb/page6_img2.jpg" idx="1" />
                        </div>
                        <div class="img1box">
                            <img src="../assets/indexb/page6_img3.jpg" idx="2" />
                        </div>
                    </div>
                    <div class="row1">
                        <div class="img0box">
                            <img src="../assets/indexb/page6_img0.jpg" idx="-1" />
                        </div>
                    </div>
                    <div class="row2">
                        <div class="img0box">
                            <img src="../assets/indexb/page6_img4.jpg" idx="6" />
                        </div>
                        <div class="img1box">
                            <img src="../assets/indexb/page6_img5.jpg" idx="5" />
                        </div>
                    </div>
                </div>
                <div class="cell cell-2">
                    <div class="img0box">
                        <img src="../assets/indexb/page6_img6.jpg" idx="3" />
                    </div>
                    <div class="row1">
                        <div class="img1box">
                            <img src="../assets/indexb/page6_img7.jpg" idx="4" />
                        </div>
                        <div class="btn-next">
                            <span>下一个</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page page7">
            <div class="gif"></div>
            <div class="logo0"></div>
            <div class="logo1"></div>
            <div class="btn" @click="toDealerUrl()">
                <span>查看经销商</span>
                <div class="add"></div>
            </div>
        </div>

        <div class="page page8">
            <div class="content">
                <div class="gif txt0"></div>
                <div class="img0 txt1"></div>
                <div class="img1 txt2"></div>
                <div class="img2 txt3"></div>
                <div class="img3 txt4"></div>
                <div class="txt"></div>
            </div>
        </div>

        <div class="page page9">
            <div class="content-0" @click="toQ8()" >
                <div class="bg"></div>
                <div class="con">
                    <div class="logo txt0"></div>
                    <div class="line txt1"></div>
                    <div class="h2 txt2">
                        <span>生于赛场，暗藏锋芒</span>
                        <div class="after" ></div>
                    </div>
                </div>
            </div>
            <div class="content-1">
                <div class="con">
                    <div class="logo txt3"></div>
                    <div class="txt txt4">一汽奥迪 <span class="en">RS</span> 旗舰双车限量登场<br />尽在奥迪</div>
                </div>
            </div>
        </div>

        <div class="swiperbox page4_swiperbox page4_swiperbox_0">
            <div class="close" @click="hideSiperBox(0)"></div>
            <div class="itembox">
                <div @click="swiperbox0Click(0)" class="item active">赛级动力</div>
                <div @click="swiperbox0Click(1)" class="item">赛级架控</div>
                <div @click="swiperbox0Click(2)" class="item">赛级制动</div>
            </div>
            <div class="contentbox">
                <div class="content content_0">
                    <div class="bg"></div>
                    <div class="textbox">
                        <div class="txt0"><span class="en">V8TFSI</span> 双涡轮增压发动机</div>
                        <div class="txt1"><span class="en">4.0L</span> 双涡轮增压 <span class="en">V8</span> 发动机，输出功率可达 <span class="en">463 kW</span>（ <span class="en">630</span> 马力），最大扭<br />矩可达 <span class="en">850 N·m</span>，百公里加速仅需 <span class="en">3.3</span> 秒，极速 <span class="en">305</span> 公里/小时，赛道巅峰，<br />纵享驾驶激情</div>
                    </div>
                </div>
                <div class="content content_1">
                    <div class="bg bg0"></div>
                    <div class="bg bg1" style="display: none"></div>
                    <div class="textbox textbox_0">
                        <div class="txt0">扭力自锁式中央差速器 <span class="en">+ quattro</span> 运动型差速器</div>
                        <div class="txt1">扭力自锁式中央差速器，驱动扭矩自动分配，有效改善驾驶动态，显著提<br />高转弯精准度。配合偏向赛道特别调校的后轴 <span class="en">quattro</span> 运动型差速器与<br /><span class="en">quattro</span> 特性的运动差速锁，尽享高精度驾驭</div>
                    </div>
                    <div class="textbox textbox_1">
                        <div class="txt0">竞赛级可调式螺旋弹簧悬架</div>
                        <div class="txt1">专属的轻量化可调式螺旋弹簧悬架，可调式螺旋弹簧悬架（绞牙避震）<br />运动型防倾杆，带全轮转向的底盘系统，尽享驾控激情</div>
                    </div>
                    <div class="arrowbox">
                        <div @click="swiperbox0PrevNext(0)" class="prev disable"></div>
                        <div @click="swiperbox0PrevNext(1)" class="next"></div>
                    </div>
                </div>
                <div class="content content_2">
                    <div class="bg"></div>
                    <div class="textbox">
                        <div class="txt0">RS 碳陶制动系统</div>
                        <div class="txt1">
                            奥迪品牌有史以来所采用的技术最硬核、性能最佳、尺寸最大的<br />
                            刹车盘，采用碳纤维增强碳化硅（ <span class="en">C/SiC</span> 陶瓷）材料，搭配同级<br />
                            罕有 <span class="en">10</span> 活塞红色卡钳，制动力均匀强劲
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="swiperbox page4_swiperbox page4_swiperbox_1">
            <div class="redbgright"></div>
            <div class="contentbox">
                <div class="content_0">
                    <div class="close" @click="hideSiperBox(1)"></div>
                    <div class="imagesbox">
                        <div class="item active">
                            <img src="../assets/indexb/page4_swiperbox_1_img0.jpg" class="img img0" />>
                            <div @click="showSwiperbox1Content1(0)" class="title">
                                <div class="add"></div>
                                <div class="txt">迎面而来</div>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/indexb/page4_swiperbox_1_img1.jpg" class="img img1" />
                            <div @click="showSwiperbox1Content1(1)" class="title">
                                <div class="add"></div>
                                <div class="txt">GT 专属</div>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/indexb/page4_swiperbox_1_img2.jpg" class="img img2" />
                            <div @click="showSwiperbox1Content1(2)" class="title">
                                <div class="add"></div>
                                <div class="txt">极致轻量</div>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/gif/gif2.gif" class="img img3" />
                            <div @click="showSwiperbox1Content1(3)" class="title">
                                <div class="add"></div>
                                <div class="txt">动人背影</div>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../assets/indexb/page4_swiperbox_1_img4.jpg" class="img img4" />
                            <div @click="showSwiperbox1Content1(4)" class="title">
                                <div class="add"></div>
                                <div class="txt">冠军涂装</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content_1">
                    <div class="close" @click="hideSwiperbox1Content1()"></div>
                    <div class="imgbox">
                        <img src="../assets/indexb/page4_swiperbox_1_img0.jpg" class="bigimg" />
                        <div class="textbox textbox0">
                            <div class="txt0">迎面而来</div>
                            <div class="txt1">
                                以传奇赛车奥迪 <span class="en">90 quattro IMSA GTO</span> 为灵感，高<br />
                                光黑一体式进气格栅和侧进气口，前裙板垂直翼<br />
                                片、全新格栅网格，尽显赛道激情
                            </div>
                        </div>
                        <div class="textbox textbox1">
                            <div class="txt0"><span class="enb">GT</span> 专属</div>
                            <div class="txt1">
                                中控印刻全球 <span class="en">660</span> 辆限量序列号，搭配黑色 <span class="en">GT</span> 徽章的<br />
                                翼子板、传承经典的 “<span class="en">RS 6 GT</span>” 尾标、黑色奥迪四环标<br />
                                与徽标、<span class="en">GT</span> 标识运动座椅等，彰显 <span class="en">GT</span> 车型与众不同<br />
                                的独特身份
                            </div>
                        </div>
                        <div class="textbox textbox2">
                            <div class="txt0">极致轻量</div>
                            <div class="txt1">
                                车身可见碳纤维部件的碳纤维引擎盖、碳纤维翼子板、<br />
                                <span class="en">RS</span> 专业级运动悬架等多重减重，较奥迪P版高性能版本<br />
                                全车身减重达 <span class="en">30 kg</span>
                            </div>
                        </div>
                        <div class="textbox textbox3">
                            <div class="txt0">动人背影</div>
                            <div class="txt1">
                                <span class="en">GT</span> 专属车顶扰流板，源于赛车基因的双层尾翼独具匠心<br />
                                搭配 <span class="en">GT</span> 专属尾门设计，视觉上降低装载边缘<br />
                                专属尾部扩散器更显宽阔型格
                            </div>
                        </div>
                        <div class="textbox textbox4">
                            <div class="txt0">冠军涂装</div>
                            <div class="txt1">
                                阿科纳白漆面涂装，结合奥迪运动经典黑、灰、红色调，<br />
                                搭配造型独特的高光白轮毂；黑灰色调涂装，搭配纳多灰<br />
                                或传奇黑，高光黑或哑光黑轮毂，更显赛道激情
                            </div>
                        </div>
                    </div>
                    <div class="smallbox">
                        <div class="item" @click="clickSwiperbox1Content1(0)">
                            <img src="../assets/indexb/page4_swiperbox_1_img0.jpg" class="img" />
                        </div>
                        <div class="item" @click="clickSwiperbox1Content1(1)">
                            <img src="../assets/indexb/page4_swiperbox_1_img1.jpg" class="img" />
                        </div>
                        <div class="item active" @click="clickSwiperbox1Content1(2)">
                            <img src="../assets/indexb/page4_swiperbox_1_img2.jpg" class="img" />
                        </div>
                        <div class="item" @click="clickSwiperbox1Content1(3)">
                            <img src="../assets/gif/gif2.gif" class="img" />
                        </div>
                        <div class="item" @click="clickSwiperbox1Content1(4)">
                            <img src="../assets/indexb/page4_swiperbox_1_img4.jpg" class="img" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="swiperbox page4_swiperbox page4_swiperbox_2">
            <div class="bgbox">
                <div class="bg"></div>
            </div>
            <div class="close" @click="closeSwiperbox2()"></div>
            <div class="hotpoint" @click="showSiperbox2Hot()"></div>
            <div class="textbox textbox_0">
                <div class="txt0">定制无处不在</div>
                <div class="txt1">
                    黑色风格基底，专属定制配色，大量使用黑色 <span class="en">Dinamica</span> 超细纤维，搭配深红<br />
                    色安全带格外引人注目。中控台印刻限量序列号，顶级仪序，极致彰显
                </div>
            </div>
            <div class="textbox textbox_1">
                <div class="txt0"><span class="enb">RS</span> 运动座椅</div>
                <div class="txt1">
                    全新 <span class="en">RS</span> 运动座椅采用华格纳真皮，兼具豪华与运动。头枕下方“<span class="en">RS 6 GT</span>”<br />
                    字样搭配蜂窝形缝线，尊属无处不在
                </div>
            </div>
        </div>

        <div class="test_driver_box">
            <div class="bg"></div>
            <div class="close" @click="hideTestDriver"></div>
            <Yuyue0 v-if="dealer " :cartype="165340"></Yuyue0>
            <Yuyue1 v-else :cartype="165340"></Yuyue1>
        </div>

        <div class="video-dialkog">
            <div class="videobox">
                <video class="video" id="video0" controls preload="auto" src="../assets/videos/video0.mp4" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline x-webkit-airplay="allow"></video>
                <div class="close" @click="hideVideoDialog"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber, calcSize, calcValue } from '../utils/index'
var lenis = null
var controller = null
var controller2 = null
var controller3 = null
var controllerDefault = null
var controller5 = null
import Yuyue0 from './components/yuyue_0.vue'
import Yuyue1 from './components/yuyue_1.vue'

export default {
    components: { Yuyue0, Yuyue1 },
    data() {
        return {
            dealer: '',
            activity: ''
        }
    },
    created() {
        this.dealer = getQueryString('dealer') 
        this.activity = getQueryString('activity') 
    },
    mounted() {
        this.bindEvents()
    },
    beforeDestroy() {
        lenis.destroy()
        controller.destroy()
        controller2.destroy()
        controller3.destroy()
        controllerDefault.destroy()
        controller5.destroy()
        TweenMax.killTweensOf('*')
        console.log('清除动画')
    },
    destroyed() {},
    methods: {
        bindEvents() {
            $(window).scrollTop(0)
            this.isShowDriver = false

            controller = new ScrollMagic.Controller({
                globalSceneOptions: { offset: -$(window).innerHeight() / 2, reverse: true }
            })

            controller2 = new ScrollMagic.Controller({
                globalSceneOptions: { offset: -$(window).innerHeight() / 2, duration: '200%' }
            })
            controller3 = new ScrollMagic.Controller({
                globalSceneOptions: { triggerHook: 'onEnter', duration: '100%' }
            })
            controllerDefault = new ScrollMagic.Controller({})
            controllerDefault.scrollTo(function (newpos) {
                // TweenMax.to(document.body, 0.5, { scrollTo: { y: newpos } })
                $('html,body').animate({ scrollTop: newpos }, 1000)
            })
            controller5 = new ScrollMagic.Controller({
                globalSceneOptions: { offset: '50%', duration: '100%' }
            })
            var that = this
            setTimeout(() => {
                that.bindPage0()
                that.bindPage1()
                that.bindPage2()
                that.bindPage3()
                that.bindPage4()
                that.bindPage5()
                that.bindPage6()
                that.bindPage7()
                that.bindPage8()
                that.bindPage9()
                that.bindLenis()
                that.bindSwiperbox1Event()
                that.bindPage6Event()
            }, 500)
        },
        bindLenis() {
            lenis = new Lenis({
                duration: 2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
                direction: 'vertical', // vertical, horizontal
                gestureDirection: 'vertical', // vertical, horizontal, both
                smooth: true,
                mouseMultiplier: 1,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false
            })
            lenis.on('scroll', (e) => {
                // controller.update(true);
                // controller2.update(true);
                // controller3.update(true);
                // controllerDefault.update(true);
                // console.log(e)
            })
            lenis.resize()
            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)
        },
        resetPage0() {
            TweenMax.set('.page0 .logo', { opacity: 0, y: 100, width: calcSize(1742), height: calcSize(201), left: calcSize(-15), top: calcSize(97) })
            TweenMax.set('.page0 .gif', { opacity: 1, y: 100, width: calcSize(1259), height: calcSize(614), left: calcSize(331), bottom: calcSize(228) })
            TweenMax.set('.page0 .num', { num: 0 })
            TweenMax.set('.page0 .number-box', { opacity: 0, y: 100 })
            TweenMax.set('.page0 .txt0', { x: -300, opacity: 0 })
            TweenMax.set('.page0 .txt1', { x: 300, opacity: 0 })
            TweenMax.set('.page0 .txt2', { y: 200, opacity: 0 })
            TweenMax.set('.page0 .txt3', { y: 200, opacity: 0 })
            TweenMax.set('.page0 .txt4', { x: -500, opacity: 0 })
            TweenMax.set('.page0 .txt5', { x: -500, opacity: 0 })
            TweenMax.set('.page0 .txt6', { x: -300, opacity: 0 })
            TweenMax.set('.page0 .txt7', { x: 300, opacity: 0 })
            TweenMax.set('.page0 .txt8', { x: -300, opacity: 0 })
            TweenMax.set('.page0 .txt9', { x: 500, opacity: 0 })
            TweenMax.set('.page0 .txt10', { x: -500, opacity: 0 })
            TweenMax.set('.page0 .txt11', { x: -500, opacity: 0 })
            TweenMax.set('.menubox', { opacity: 0, y: calcSize(-103) })
        },
        bindPage0() {
            var that = this
            this.resetPage0()
            TweenMax.to('.page0 .logo', 0.5, { opacity: 1, y: 0 })
            TweenMax.to('.page0 .gif', 0.5, { opacity: 1, y: 0, delay: 0.2 })
            TweenMax.to('.page0 .number-box', 0.5, { opacity: 1, y: 0, delay: 0.4 })
            var tween = TweenMax.to('.page0 .num', 1, {
                num: 66,
                delay: 0.6,
                onUpdate: () => {
                    var num = parseInt(tween.progress() * 66)
                    $('.page0 .num').html(num)
                }
            })

            var w = $(window).width()
            var logoTop = $(window).height() - calcValue(166)
            var anim = new TimelineMax()
            anim.to('.page0 .logo', 1, { opacity: 0.2, left: calcSize(862), top: calcSize(logoTop), width: calcSize(1054), height: calcSize(122) })
            anim.to('.page0 .gif', 1, { width: calcSize(416), height: calcSize(203), left: calcSize(570), top: calcSize(164) }, 0)
            anim.to('.page0 .number-box', 1, { opacity: 0, y: calcSize(200) }, 0)
            anim.to('.page0 .txt0', 1, { opacity: 1, x: 0 }, 1)
            anim.to('.page0 .txt1', 1, { opacity: 1, x: 0 }, 1.2)
            anim.to('.page0 .txt2', 1, { opacity: 1, y: 0 }, 1.4)
            anim.to('.page0 .txt3', 1, { opacity: 1, y: 0 }, 1.6)
            anim.to('.page0 .txt3', 1, { opacity: 0, y: 200 }, 2.6)
            anim.to('.page0 .txt2', 1, { opacity: 0, y: 200 }, 2.8)
            anim.to('.page0 .txt1', 1, { opacity: 0, x: 300 }, 3.0)
            anim.to('.page0 .txt0', 1, { opacity: 0, x: -300 }, 3.2)
            anim.to('.page0 .gif', 1.5, { left: calcSize(557), top: calcSize(586) }, 3.4)
            anim.to('.page0 .txt4', 1, { opacity: 1, x: 0 }, 4.4)
            anim.to('.page0 .txt5', 1, { opacity: 1, x: 0 }, 4.6)
            anim.to('.page0 .txt6', 1, { opacity: 1, x: 0 }, 4.8)
            anim.to('.page0 .txt7', 1, { opacity: 1, x: 0 }, 5.0)
            anim.to('.page0 .txt7', 1, { opacity: 0, x: 300 }, 6.0)
            anim.to('.page0 .txt6', 1, { opacity: 0, x: -300 }, 6.2)
            anim.to('.page0 .txt5', 1, { opacity: 0, x: -500 }, 6.4)
            anim.to('.page0 .txt4', 1, { opacity: 0, x: -500 }, 6.6)
            anim.to('.page0 .gif', 1.5, { left: calcSize(419), top: calcSize(234) }, 6.8)
            anim.to('.page0 .txt8', 1, { opacity: 1, x: 0 }, 7.8)
            anim.to('.page0 .txt9', 1, { opacity: 1, x: 0 }, 8.0)
            anim.to('.page0 .txt10', 1, { opacity: 1, x: 0 }, 8.2)
            anim.to('.page0 .txt11', 1, { opacity: 1, x: 0 }, 8.4)
            // anim.to('.page0 .logo', 1, { opacity: 1, left: calcSize(325), top: calcSize(48), width: calcSize(273), height: calcSize(31) }, 9.4)
            anim.to('.page0 .txt11', 0.5, {
                onComplete: () => {
                    // TweenMax.to('.menubox', 0.5, { opacity: 1, y: calcSize(0) })
                }
            })

            var playAnim = function () {
                TweenMax.to('.menubox', 0.5, { opacity: 0, y: calcSize(-103) })
            }
            new ScrollMagic.Scene({ triggerElement: '.page0', triggerHook: 'onLeave', duration: '500%' })
                .setPin('.page0')
                .setTween(anim)
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page0 start')
                })
                .on('enter', function () {
                    console.log('page0 enter')
                    that.resetPage1()
                    playAnim()
                })
                .on('leave', () => {
                    console.log('page0 leave')
                })
        },
        resetPage1() {
            TweenMax.set('.page1 .price-box', { opacity: 0, y: calcSize(200) })
            TweenMax.set('.page1 .btn-dealer', { opacity: 0, y: calcSize(200) })
        },
        bindPage1() {
            var that = this
            var playAnim = function () {
                TweenMax.to('.page1 .price-box', 0.5, { opacity: 1, y: 0 })
                TweenMax.to('.page1 .btn-dealer', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                TweenMax.to('.menubox', 0.5, { opacity: 1, y: calcSize(0) })
            }
            new ScrollMagic.Scene({ triggerElement: '.page1', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page1')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page1 start')
                })
                .on('enter', function () {
                    console.log('page1 enter')
                    playAnim()
                    that.resetPage2()
                })
                .on('leave', () => {
                    console.log('page1 leave')
                })
        },
        resetPage2() {
            TweenMax.set('.page2 .item', { opacity: 0, y: calcSize(200) })
        },
        bindPage2() {
            var that = this
            var playAnim = function () {
                for (var i = 0; i < 3; i++) {
                    TweenMax.to('.page2 .item' + i, 0.5, { opacity: 1, y: 0, delay: i * 0.2 })
                }
            }
            new ScrollMagic.Scene({ triggerElement: '.page2', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page2')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page2 start')
                })
                .on('enter', function () {
                    console.log('page2 enter')
                    playAnim()
                    that.resetPage3()
                })
                .on('leave', () => {
                    console.log('page2 leave')
                })
        },
        resetPage3() {
            TweenMax.set('.page3 .bg1', { opacity: 1, x: '100vw' })
            TweenMax.set('.page3 .txt0', { opacity: 0, x: calcSize(-200) })
            TweenMax.set('.page3 .txt1', { opacity: 0, x: calcSize(-200) })
        },
        bindPage3() {
            var that = this
            var anim = new TimelineMax()
            anim.to('.page3 .textbox0', 2, {
                onStart: () => {
                    TweenMax.to('.page3 .textbox0 .txt0', 0.5, { opacity: 1, x: 0, delay: 0 })
                    TweenMax.to('.page3 .textbox0 .txt1', 0.5, { opacity: 1, x: 0, delay: 0.2 })
                }
            })
            anim.to('.page3 .textbox0', 2, {
                onStart: () => {
                    TweenMax.to('.page3 .bg1', 1, { opacity: 1, x: 0, delay: 0 })
                    TweenMax.to('.page3 .textbox0 .txt0', 0.5, { opacity: 0, x: calcSize(-200), delay: 0.2 })
                    TweenMax.to('.page3 .textbox0 .txt1', 0.5, { opacity: 0, x: calcSize(-200), delay: 0.4 })
                    TweenMax.to('.page3 .textbox1 .txt0', 0.5, { opacity: 1, x: 0, delay: 0.8 })
                    TweenMax.to('.page3 .textbox1 .txt1', 0.5, { opacity: 1, x: 0, delay: 1 })
                }
            })
            anim.to('.page3 .textbox0', 2, {})

            new ScrollMagic.Scene({ triggerElement: '.page3', triggerHook: 'onLeave', duration: '200%' })
                .setPin('.page3')
                .addTo(controllerDefault)
                .setTween(anim)
                .on('start', function () {
                    console.log('page3 start')
                })
                .on('enter', function () {
                    console.log('page3 enter')
                    // playAnim()
                    that.resetPage4()
                })
                .on('leave', () => {
                    console.log('page3 leave')
                })
        },
        resetPage4() {
            TweenMax.set('.page4 .item', { opacity: 0, y: calcSize(200) })
        },
        bindPage4() {
            var that = this
            var playAnim = function () {
                for (var i = 0; i < 3; i++) {
                    TweenMax.to('.page4 .item' + i, 0.5, { opacity: 1, y: 0, delay: i * 0.2 })
                }
            }
            new ScrollMagic.Scene({ triggerElement: '.page4', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page4')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page4 start')
                })
                .on('enter', function () {
                    console.log('page4 enter')
                    playAnim()
                    that.resetPage5()
                })
                .on('leave', () => {
                    console.log('page4 leave')
                })
        },
        resetPage5() {
            TweenMax.set('.page5 .txt0', { opacity: 0, y: calcSize(200) })
            TweenMax.set('.page5 .txt1', { opacity: 0, y: calcSize(200) })
        },
        bindPage5() {
            var that = this
            var playAnim = function () {
                TweenMax.to('.page5 .txt0', 0.5, { opacity: 1, y: 0, delay: 0 })
                TweenMax.to('.page5 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.2 })
            }
            new ScrollMagic.Scene({ triggerElement: '.page5', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page5')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page5 start')
                })
                .on('enter', function () {
                    console.log('page5 enter')
                    playAnim()
                    that.resetPage6()
                })
                .on('leave', () => {
                    console.log('page5 leave')
                })
        },
        resetPage6() {
            T
        },
        bindPage6() {
            var that = this
            var playAnim = function () {}
            new ScrollMagic.Scene({ triggerElement: '.page6', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page6')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page6 start')
                })
                .on('enter', function () {
                    console.log('page6 enter')
                    playAnim()
                    that.resetPage7()
                })
                .on('leave', () => {
                    console.log('page6 leave')
                })
        },
        bindPage6Event() {
            var that = this
            this.page4SelectIndex = 0
            var imageList = []
            $('.image-grid img').each(function (i, el) {
                var idx = parseInt($(el).attr('idx'))
                if (idx >= 0) {
                    var src = $(el).attr('src')
                    imageList.push({
                        idx: idx,
                        src: src,
                        target: el
                    })
                    $(el).click(function () {
                        $('.image-grid img').removeClass('active')
                        $(el).addClass('active')
                        that.page4SelectIndex = idx
                        $('.image-grid .cell-1 .row1 img').attr('src', src)
                    })
                }
            })
            $('.image-grid .btn-next').click(function () {
                that.page4SelectIndex++
                if (that.page4SelectIndex >= 8) {
                    that.page4SelectIndex = 0
                }
                var item = imageList.find((it) => {
                    return it.idx == that.page4SelectIndex
                })
                if (item) {
                    item.target.click()
                }
            })
        },
        resetPage7() {
            TweenMax.set('.page7 .gif', { scale: 0.27 })
            TweenMax.set('.page7 .logo0', { left: calcSize(250), width: calcSize(330), height: calcSize(89) })
            TweenMax.set('.page7 .logo1', { right: calcSize(250), width: calcSize(414), height: calcSize(89) })
            TweenMax.set('.page7 .btn', { opacity: 0, y: calcSize(200) })
        },
        bindPage7() {
            var that = this
            var playAnim = function () {
                TweenMax.to('.page7 .gif', 1, { scale: 1 })
                TweenMax.to('.page7 .logo0', 0.5, { left: calcSize(163), width: calcSize(685), height: calcSize(185) })
                TweenMax.to('.page7 .logo1', 0.5, { right: calcSize(163), width: calcSize(861), height: calcSize(185) })
                TweenMax.to('.page7 .btn', 0.5, { opacity: 1, y: 0, delay: 0.4 })
            }
            new ScrollMagic.Scene({ triggerElement: '.page7', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page7')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page7 start')
                })
                .on('enter', function () {
                    console.log('page7 enter')
                    playAnim()
                    that.resetPage8()
                })
                .on('leave', () => {
                    console.log('page7 leave')
                })
        },
        resetPage8() {
            TweenMax.set('.page8 .gif', { opacity: 0, x: 0, y: calcSize(100), left: calcSize(331), top: calcSize(238), width: calcSize(1260), height: calcSize(614) })
            TweenMax.set('.page8 .img0', { opacity: 0, x: 0, y: calcSize(100), left: calcSize(243), top: calcSize(145), width: calcSize(841), height: calcSize(292) })
            TweenMax.set('.page8 .img1', { opacity: 0, x: 0, y: calcSize(100), left: calcSize(1213), top: calcSize(290), width: calcSize(498), height: calcSize(373) })
            TweenMax.set('.page8 .img2', { opacity: 0, x: 0, y: calcSize(100), left: calcSize(128), top: calcSize(612), width: calcSize(476), height: calcSize(356) })
            TweenMax.set('.page8 .img3', { opacity: 0, x: 0, y: calcSize(100), left: calcSize(846), top: calcSize(770), width: calcSize(846), height: calcSize(770) })
            TweenMax.set('.page8 .txt', { opacity: 1, y: calcSize(2000) })
        },
        bindPage8() {
            var that = this
            var anim = new TimelineMax()
            anim.to('.page8', 2, {
                onStart: () => {
                    TweenMax.to('.page8 .gif', 0.5, { opacity: 1, y: 0, delay: 0 })
                    TweenMax.to('.page8 .img0', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                    TweenMax.to('.page8 .img1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
                    TweenMax.to('.page8 .img2', 0.5, { opacity: 1, y: 0, delay: 0.6 })
                    TweenMax.to('.page8 .img3', 0.5, { opacity: 1, y: 0, delay: 0.8 })
                }
            })
            anim.to('.page8', 2, {
                onStart: () => {
                    TweenMax.to('.page8 .gif', 0.5, { opacity: 0, y: calcSize(-300), delay: 0.0 })
                    TweenMax.to('.page8 .img0', 0.5, { opacity: 1, x: calcSize(-300), y: calcSize(-300), delay: 0.0 })
                    TweenMax.to('.page8 .img1', 0.5, { opacity: 1, x: calcSize(300), y: calcSize(-300), delay: 0.1 })
                    TweenMax.to('.page8 .img2', 0.5, { opacity: 0, y: calcSize(-300), delay: 0.2 })
                    TweenMax.to('.page8 .img3', 0.5, { opacity: 0, y: calcSize(-300), delay: 0.3 })
                    TweenMax.to('.page8 .txt', 1, { opacity: 1, y: '-50%', delay: 0.1 })
                }
            })
            anim.to('.page8', 1, {})
            new ScrollMagic.Scene({ triggerElement: '.page8', triggerHook: 'onLeave', duration: '150%' })
                .setPin('.page8')
                .addTo(controllerDefault)
                .setTween(anim)
                .on('start', function () {
                    console.log('page8 start')
                })
                .on('enter', function () {
                    console.log('page8 enter')
                    that.resetPage9()
                })
                .on('leave', () => {
                    console.log('page8 leave')
                })
        },
        resetPage9() {
            for (var i = 0; i < 5; i++) {
                TweenMax.set('.page9 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        bindPage9() {
            var that = this
            var playAnim = function () {
                for (var i = 0; i < 5; i++) {
                    TweenMax.to('.page9 .txt' + i, 0.5, { opacity: 1, y: 0, delay: i * 0.15 })
                }
            }
            new ScrollMagic.Scene({ triggerElement: '.page9', triggerHook: 'onLeave', duration: '50%' })
                .setPin('.page9')
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page9 start')
                })
                .on('enter', function () {
                    console.log('page9 enter')
                    playAnim()
                })
                .on('leave', () => {
                    console.log('page9 leave')
                })
        },
        toPage(name) {
            controllerDefault.scrollTo(name)
        },
        onEnterPage4Item(idx) {
            $('.page4 .imgbox').each(function (i, el) {
                $(el).stop()
                if (idx + 1 == i) {
                    $(el).fadeIn()
                } else {
                    $(el).fadeOut()
                }
            })
        },
        onLeavePage4Item() {
            $('.page4 .imgbox').each(function (i, el) {
                $(el).stop()
                if (i == 0) {
                    $(el).fadeIn()
                } else {
                    $(el).fadeOut()
                }
            })
        },
        showSwiperBox(idx, e) {
            // $('.page4 .item').removeClass('active')
            // $('.page4 .item' + idx).addClass('active')
            if (idx == 0) {
                TweenMax.set('.page4_swiperbox_0 .txt0', { opacity: 0, y: 100 })
                TweenMax.set('.page4_swiperbox_0 .txt1', { opacity: 0, y: 100 })
                TweenMax.set('.page4_swiperbox_0 .content_0', { display: 'block' })
                TweenMax.set('.page4_swiperbox_0 .content_1', { display: 'none' })
                TweenMax.set('.page4_swiperbox_0 .content_2', { display: 'none' })
                TweenMax.set('.page4_swiperbox_0 .content_1 .bg0', { display: 'block' })
                TweenMax.set('.page4_swiperbox_0 .content_1 .bg1', { display: 'none' })
                $('.page4_swiperbox_0 .content_1 .arrowbox .prev').addClass('disable')
                $('.page4_swiperbox_0 .content_1 .arrowbox .next').removeClass('disable')
                $('.page4_swiperbox_0 .itembox .item').removeClass('active')
                $('.page4_swiperbox_0 .itembox .item').eq(0).addClass('active')
                TweenMax.set('.page4_swiperbox_0', { display: 'block', opacity: 0 })
                TweenMax.to('.page4_swiperbox_0', 0.5, { opacity: 1 })
                this.swiperbox0Index = 0
            } else if (idx == 1) {
                $('.page4_swiperbox_1 .content_0').show()
                $('.page4_swiperbox_1 .content_1').hide()
                TweenMax.set('.page4_swiperbox_1', { display: 'block', opacity: 0 })
                TweenMax.to('.page4_swiperbox_1', 0.5, { opacity: 1 })
            } else if (idx == 2) {
                this.swiperbox2Index = 0
                TweenMax.set('.page4_swiperbox_2 .txt0', { opacity: 0, y: 100 })
                TweenMax.set('.page4_swiperbox_2 .txt1', { opacity: 0, y: 100 })
                TweenMax.set('.page4_swiperbox_2 .hotpoint', { opacity: 1, display: 'block' })
                TweenMax.set('.page4_swiperbox_2 .bg', { scale: 1 })
                TweenMax.set('.page4_swiperbox_2', { display: 'block', opacity: 0 })
                TweenMax.to('.page4_swiperbox_2', 0.5, { opacity: 1 })
                TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.3 })
                TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
            }
        },
        closeSwiperbox2() {
            if (this.swiperbox2Index == 0) {
                $('.page4_swiperbox_2').fadeOut()
            } else {
                this.swiperbox2Index = 0
                TweenMax.to('.page4_swiperbox_2 .bg', 0.5, { scale: 1 })
                TweenMax.to('.page4_swiperbox_2 .hotpoint', 0.5, { opacity: 1, display: 'block' })
                TweenMax.to('.page4_swiperbox_2 .textbox_1 .txt1', 0.5, { opacity: 0, y: 100 })
                TweenMax.to('.page4_swiperbox_2 .textbox_1 .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
                TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.3 })
                TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
            }
        },
        showSiperbox2Hot() {
            this.swiperbox2Index = 1
            TweenMax.to('.page4_swiperbox_2 .bg', 0.5, { scale: 1.6 })
            TweenMax.to('.page4_swiperbox_2 .hotpoint', 0.5, { opacity: 0, display: 'none' })
            TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt1', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page4_swiperbox_2 .textbox_0 .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
            TweenMax.to('.page4_swiperbox_2 .textbox_1 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.3 })
            TweenMax.to('.page4_swiperbox_2 .textbox_1 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
        },
        hideSiperBox(idx) {
            $('.page4_swiperbox_' + idx).fadeOut()
        },
        swiperbox0Click(idx) {
            $('.page4_swiperbox_0 .itembox .item').removeClass('active')
            $('.page4_swiperbox_0 .itembox .item').eq(idx).addClass('active')
            for (var i = 0; i <= 2; i++) {
                if (i == idx) {
                    $('.page4_swiperbox_0 .content_' + i).fadeIn()
                    if (idx == 1) {
                        if (this.swiperbox0Index == 0) {
                            TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .textbox_0 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.0 })
                            TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .textbox_0 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                        } else {
                            TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .textbox_1 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.0 })
                            TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .textbox_1 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                        }
                    } else {
                        TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .txt0', 0.5, { opacity: 1, y: 0, delay: 0.0 })
                        TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .txt1', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                    }
                } else {
                    TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .txt1', 0.5, { opacity: 0, y: 100 })
                    TweenMax.to('.page4_swiperbox_0 .content_' + i + ' .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
                    $('.page4_swiperbox_0 .content_' + i).fadeOut()
                }
            }
        },
        swiperbox0PrevNext(type) {
            if (type == 0) {
                if (this.swiperbox0Index == 0) return
                this.swiperbox0Index = 0
                $('.page4_swiperbox_0 .content_1 .bg0').fadeIn()
                $('.page4_swiperbox_0 .content_1 .bg1').fadeOut()
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_1 .txt1', 0.5, { opacity: 0, y: 100 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_1 .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_0 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.3 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_0 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
                $('.page4_swiperbox_0 .content_1 .arrowbox .prev').addClass('disable')
                $('.page4_swiperbox_0 .content_1 .arrowbox .next').removeClass('disable')
            } else {
                if (this.swiperbox0Index == 1) return
                this.swiperbox0Index = 1
                $('.page4_swiperbox_0 .content_1 .bg0').fadeOut()
                $('.page4_swiperbox_0 .content_1 .bg1').fadeIn()
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_0 .txt1', 0.5, { opacity: 0, y: 100 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_0 .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_1 .txt0', 0.5, { opacity: 1, y: 0, delay: 0.3 })
                TweenMax.to('.page4_swiperbox_0 .content_1 .textbox_1 .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
                $('.page4_swiperbox_0 .content_1 .arrowbox .prev').removeClass('disable')
                $('.page4_swiperbox_0 .content_1 .arrowbox .next').addClass('disable')
            }
        },
        hideSwiperbox1Content1() {
            $('.page4_swiperbox_1 .content_1').fadeOut()
            $('.page4_swiperbox_1 .content_0').fadeIn()
        },
        showSwiperbox1Content1(idx) {
            this.swiperbox1Index = idx
            TweenMax.set('.page4_swiperbox_1 .content_1 .txt0', { opacity: 0, y: 100 })
            TweenMax.set('.page4_swiperbox_1 .content_1 .txt1', { opacity: 0, y: 100 })
            $('.page4_swiperbox_1 .content_0').fadeOut()
            $('.page4_swiperbox_1 .content_1').fadeIn()
            $('.page4_swiperbox_1 .content_1 .item').removeClass('active')
            $('.page4_swiperbox_1 .content_1 .item').eq(idx).addClass('active')
            var src = $('.page4_swiperbox_1 .content_1 .item').eq(idx).find('.img').attr('src')
            $('.page4_swiperbox_1 .content_1 .bigimg').attr('src', src)
            TweenMax.to('.page4_swiperbox_1 .content_1 .textbox'+idx+' .txt0', 0.5, { opacity: 1, y: 0, delay: 0.5 })
            TweenMax.to('.page4_swiperbox_1 .content_1 .textbox'+idx+' .txt1', 0.5, { opacity: 1, y: 0, delay: 0.7 })
        },
        bindSwiperbox1Event() {
            var that = this
            this.swiperbox1Index = 0
            $('.page4_swiperbox_1 .imagesbox').on('mouseenter', function () {
                console.log('imagesbox over')
                $('.page4_swiperbox_1 .imagesbox .item').removeClass('active')
            })
            $('.page4_swiperbox_1 .imagesbox').on('mouseleave', function () {
                console.log('imagesbox out')
                $('.page4_swiperbox_1 .imagesbox .item').eq(that.swiperbox1Index).addClass('active')
            })
            $('.page4_swiperbox_1 .smallbox').on('mouseenter', function () {
                $('.page4_swiperbox_1 .smallbox .item').removeClass('active')
            })
            $('.page4_swiperbox_1 .smallbox').on('mouseleave', function () {
                $('.page4_swiperbox_1 .smallbox .item').eq(that.swiperbox1Index).addClass('active')
            })
        },
        clickSwiperbox1Content1(idx) {
            this.swiperbox1Index = idx
            $('.page4_swiperbox_1 .content_0 .item').removeClass('active')
            $('.page4_swiperbox_1 .content_0 .item').eq(idx).addClass('active')
            $('.page4_swiperbox_1 .content_1 .item').removeClass('active')
            $('.page4_swiperbox_1 .content_1 .item').eq(idx).addClass('active')
            var src = $('.page4_swiperbox_1 .content_1 .item').eq(idx).find('.img').attr('src')
            $('.page4_swiperbox_1 .content_1 .bigimg').attr('src', src)

            for (var i = 0; i < 5; i++) {
                if (i == idx) {
                    TweenMax.to('.page4_swiperbox_1 .content_1 .textbox' + i + ' .txt0', 0.5, { opacity: 1, y: 0, delay: 0.2 })
                    TweenMax.to('.page4_swiperbox_1 .content_1 .textbox' + i + ' .txt1', 0.5, { opacity: 1, y: 0, delay: 0.4 })
                } else {
                    TweenMax.to('.page4_swiperbox_1 .content_1 .textbox' + i + ' .txt1', 0.5, { opacity: 0, y: 100, delay: 0.0 })
                    TweenMax.to('.page4_swiperbox_1 .content_1 .textbox' + i + ' .txt0', 0.5, { opacity: 0, y: 100, delay: 0.1 })
                }
            }
        },
        toQ8() {
            this.$router.replace('/indexa')
            try{
                stm_clicki('send', 'event', 'RS', '点击', 'RS Q8 quattro 45周年纪念版',1);
            }catch(e){
                
            }
        },
        showTestDriver() {
            this.isShowDriver = !this.isShowDriver
            if (this.isShowDriver) {
                $('.test_driver_box').fadeIn()
            } else {
                $('.test_driver_box').fadeOut()
            }
        },
        hideTestDriver() {
            this.isShowDriver = false
            $('.test_driver_box').fadeOut()
        },
        showVideoDialog(){
            $(".video-dialkog").fadeIn();
            try{
                $("#video0")[0].play();
            }catch(e){}
        },
        hideVideoDialog(){
            $(".video-dialkog").fadeOut(); 
            try{
                $("#video0")[0].pause();
            }catch(e){}
        }
    }
}
</script>
<style scoped lang="scss">
.indexbPage {
    position: relative;
    width: 100%;
    background: #000;
    color: #fff;
    .bg {
        width: 100%;
        height: 100%;
    }
    .redbg {
        position: absolute;
        background: url(../assets/indexb/redbg.png) no-repeat center center;
        background-size: contain;
        width: 3253px;
        height: 2528px;
        z-index: 1;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        animation: redbg_anim 10s infinite;
        @keyframes redbg_anim {
            0% {
                transform: translateX(0) translateY(-50%);
            }
            20% {
                transform: translateX(200px) translateY(-40%);
            }
            50% {
                transform: translateX(400px) translateY(-45%);
            }
            70% {
                transform: translateX(200px) translateY(-60%);
            }
            100% {
                transform: translateX(0px) translateY(-50%);
            }
        }
    }
    .redbgright {
        position: absolute;
        background: url(../assets/indexb/redbg.png) no-repeat center center;
        background-size: contain;
        width: 3253px;
        height: 2528px;
        z-index: 1;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        animation: redbg_anim 10s infinite;
        @keyframes redbg_anim {
            0% {
                transform: translateX(0) translateY(-50%);
            }
            20% {
                transform: translateX(-200px) translateY(-40%);
            }
            50% {
                transform: translateX(-400px) translateY(-45%);
            }
            70% {
                transform: translateX(-200px) translateY(-60%);
            }
            100% {
                transform: translateX(0px) translateY(-50%);
            }
        }
    }
    .menubox {
        width: 1270px;
        height: 85px;
        position: fixed;
        left: 325px;
        top: 18px;
        z-index: 300;
        transform: translateY(-103px);
        .ulbox {
            width: 1114px;
            height: 85px;
            background: url(../assets/indexb/menu_bg.png) no-repeat center center;
            background-size: contain;
            margin-left: 100px;
            top: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .item {
                word-break: keep-all;
                white-space: nowrap;
                padding: 0 20px;
                line-height: 85px;
                color: rgba(255, 255, 255, 0.7);
                cursor: pointer;
            }
        }
        .logo {
            width: 273px;
            height: 31px;
            background: url(../assets/indexb/logo.png) no-repeat center center;
            background-size: contain;
            z-index: 10;
            position: absolute;
            left: 0;
            top: 26px;
        }
        .btn-yuyue {
            background: url(../assets/indexb/menu_yuyue.png) no-repeat center center;
            background-size: contain;
            width: 184px;
            height: 53px;
            line-height: 53px;
            text-align: center;
            font-size: 18px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 16px;
        }
    }
    .page {
        width: 100%;
        height: 100vh;
        background-color: #000;
        position: relative;
        left: 0;
        top: 0;
        overflow: hidden;
    }
    .page0 {
        .bg {
            width: 100%;
            height: 100%;
            background: #000 url(../assets/indexb/page0_bg.jpg) no-repeat;
            background-size: 100% 100%;
        }
        .logo {
            width: 1742px;
            height: 201px;
            position: absolute;
            left: -15px;
            top: 97px;
            z-index: 4;
            background: url(../assets/indexb/logo.png) no-repeat center center;
            background-size: contain;
            opacity: 0;
        }
        .gif {
            position: absolute;
            left: 331px;
            bottom: 228px;
            width: 1259px;
            height: 614px;
            display: block;
            z-index: 10;
            opacity: 0;
            pointer-events: all;
            cursor: pointer;
        }
        .number-box {
            position: absolute;
            right: 114px;
            bottom: 57px;
            width: 846px;
            height: 171px;
            z-index: 10;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            opacity: 0;
            .num_box {
                width: 716px;
                height: 171px;
                line-height: 171px;
                background: url(../assets/indexb/page0_txt0.png) no-repeat left center;
                background-size: contain;
                .num {
                    font-family: 'AudiTypeExtendedBold';
                    font-size: 140px;
                    line-height: 171px;
                    letter-spacing: 14px;
                    padding-left: 464px;
                }
            }
            .num_c {
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                padding-top: 72px;
                padding-left: 0px;
                word-break: keep-all;
                white-space: nowrap;
            }
        }

        .txt {
            position: absolute;
            z-index: 10;
            opacity: 0;
        }

        .txt0 {
            position: absolute;
            left: 41px;
            top: 220px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt1 {
            position: absolute;
            left: 939px;
            top: 413px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt2 {
            position: absolute;
            left: 67px;
            top: 606px;
            line-height: 96px;
            font-size: 80px;
            word-break: keep-all;
            white-space: nowrap;
            color: #f50537;
        }
        .txt3 {
            position: absolute;
            left: 67px;
            top: 726px;
            line-height: 44px;
            font-size: 36px;
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt4 {
            position: absolute;
            left: 67px;
            top: 264px;
            line-height: 96px;
            font-size: 80px;
            word-break: keep-all;
            white-space: nowrap;
            color: #f50537;
        }
        .txt5 {
            position: absolute;
            left: 67px;
            top: 384px;
            line-height: 44px;
            font-size: 36px;
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt6 {
            position: absolute;
            left: 62px;
            top: 525px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt7 {
            position: absolute;
            left: 1058px;
            top: 652px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt8 {
            position: absolute;
            left: 57px;
            top: 234px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt9 {
            position: absolute;
            left: 335px;
            top: 373px;
            line-height: 127px;
            font-size: 103px;
            font-family: 'AudiTypeExtendedBold';
            word-break: keep-all;
            white-space: nowrap;
        }
        .txt10 {
            position: absolute;
            left: 67px;
            top: 606px;
            line-height: 96px;
            font-size: 80px;
            word-break: keep-all;
            white-space: nowrap;
            color: #f50537;
        }
        .txt11 {
            position: absolute;
            left: 67px;
            top: 726px;
            line-height: 44px;
            font-size: 36px;
            word-break: keep-all;
            white-space: nowrap;
        }
    }

    .page1 {
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page1_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .price-box {
            padding-top: 256px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            z-index: 3;
            .price {
                font-size: 108px;
                line-height: 1;
                font-family: 'AudiTypeGBWideBold';
                background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.1));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
            .texts {
                padding-left: 20px;
                .txt0 {
                    font-size: 32px;
                    line-height: 1;
                    padding-top: 14px;
                }
                .txt1 {
                    font-size: 50px;
                    line-height: 1;
                    font-family: 'audi_wide_light_4.03';
                }
            }
        }
        .btn-dealer {
            width: 168px;
            height: 49px;
            position: absolute;
            top: 408px;
            left: 878px;
            border: 1px solid #fff;
            border-radius: 0;
            text-align: center;
            line-height: 49px;
            font-size: 20px;
            cursor: pointer;
        }
    }

    .page2 {
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page2_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .textbox {
            position: absolute;
            left: 160px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 3;
            .item {
                width: 50%;
                margin-bottom: 70px;
                .numbox {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    .num {
                        font-size: 96px;
                        line-height: 117px;
                        font-family: 'audi_wide_light_4.03';
                    }
                    .dw {
                        padding-top: 78px;
                        padding-left: 10px;
                        font-size: 32px;
                        line-height: 39px;
                        font-family: 'audi_extended_normal_4.03';
                        word-break: keep-all;
                        white-space: nowrap;
                    }
                }
                .label {
                    font-size: 20px;
                    line-height: 24px;
                }
            }
        }
    }

    .page3 {
        .bg0 {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page3_bg0.jpg) no-repeat center center;
            background-size: cover;
            position: absolute;
            left: 0;
            top: 0;
        }
        .bg1 {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page3_bg1.jpg) no-repeat center center;
            background-size: cover;
            transform: translateX(100%);
            z-index: 2;
            position: absolute;
            left: 0;
            top: 0;
        }
        .textbox {
            position: absolute;
            left: 127px;
            top: 223px;
            z-index: 3;
            width: 70%;
            .txt0 {
                font-size: 64px;
                line-height: 78px;
                font-family: 'AudiTypeExtendedBold';
            }
            .txt1 {
                font-size: 48px;
                line-height: 58px;
                margin-top: 40px;
            }
        }
    }

    .page4 {
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page4_bg.jpg) no-repeat center center;
            background-size: 100% 100%;
        }
        .leftcon {
            position: absolute;
            left: 0;
            top: 0;
            width: 720px;
            height: 100%;
            overflow: hidden;
            z-index: 3;
            .imgbox {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                display: none;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        .rightcon {
            position: absolute;
            left: 720px;
            top: 0;
            width: 1200px;
            height: 100%;
            z-index: 3;
            .itembox {
                padding: 148px 0 0 66px;
                .item {
                    width: 1130px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    position: relative;
                    font-size: 32px;
                    line-height: 38px;
                    color: rgba(255, 255, 255, 0.7);
                    padding: 35px 0;
                    transition: font-size 0.4s, line-height 0.5s, color 0.5s;
                    .add {
                        width: 40px;
                        height: 40px;
                        background: url(../assets/indexb/add.png) no-repeat center center;
                        background-size: contain;
                        margin-top: 40px;
                        margin-bottom: 0px;
                        display: none;
                        flex-shrink: 0;
                        cursor: pointer;
                    }
                    &:hover,
                    &.active {
                        font-size: 46px;
                        line-height: 55px;
                        color: rgba(255, 255, 255, 1);
                        background: url(../assets/indexb/page4_item_bg0.png) no-repeat right center;
                        background-size: auto 80%;
                        &.item1 {
                            background: url(../assets/indexb/page4_item_bg1.png) no-repeat right center;
                            background-size: auto 80%;
                        }
                        &.item2 {
                            background: url(../assets/indexb/page4_item_bg2.png) no-repeat right center;
                            background-size: auto 80%;
                        }
                        .add {
                            display: block;
                        }
                    }
                    &:after {
                        content: ' ';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.1));
                    }
                }
            }
        }
    }

    .page5 {
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page5_bg.jpg) no-repeat center center;
            background-size: 100% 100%;
        }
        .textbox {
            position: absolute;
            left: 164px;
            bottom: 232px;
            .txt0 {
                font-size: 48px;
                line-height: 58px;
            }
            .txt1 {
                font-size: 20px;
                line-height: 24px;
                margin-top: 20px;
            }
        }
    }

    .page6 {
        z-index: 6;
        background: url(../assets/indexb/page6_bg.jpg) no-repeat center center;
        background-size: 100% 100%;
        .image-grid {
            position: absolute;
            left: 0;
            top: 103px;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .cell-0 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .img1box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
            }
            .cell-1 {
                width: 1272px;
                height: 100%;
                display: flex;
                flex-direction: column;
                .row0 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: calc(100% - 250px);
                    .img0box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
                .row2 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
            }
            .cell-2 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    .img1box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .btn-next {
                        width: 100%;
                        height: 127px;
                        background-color: #7c001a;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        flex-shrink: 0;
                        cursor: pointer;
                        span {
                            font-size: 18px;
                            line-height: 1.2;
                            background: url(../assets/indexa/page4_arrow.png) no-repeat right center;
                            background-size: auto 20px;
                            padding-right: 25px;
                        }
                    }
                }
            }
        }
    }

    .page7 {
        z-index: 6;
        background: url(../assets/indexb/page6_bg.jpg) no-repeat center center;
        background-size: 100% 100%;
        .gif {
            width: 100%;
            height: 100%;
            transform: scale(0.27);
            background: url(../assets/gif/gif0.gif);
            background-size: cover;
        }
        .logo0 {
            width: 330px;
            height: 89px;
            background: url(../assets/indexb/logo.png) no-repeat left center;
            background-size: auto 100%;
            position: absolute;
            left: 250px;
            top: 50%;
            transform: translateY(-50%);
        }
        .logo1 {
            width: 414px;
            height: 89px;
            background: url(../assets/indexb/logo.png) no-repeat right center;
            background-size: auto 100%;
            position: absolute;
            right: 250px;
            top: 50%;
            transform: translateY(-50%);
        }
        .btn {
            position: absolute;
            left: 50%;
            top: 744px;
            width: 250px;
            text-align: center;
            font-size: 38px;
            line-height: 46px;
            z-index: 10;
            transform: translate(-50%, -50%);
            word-break: keep-all;
            white-space: nowrap;
            cursor: pointer;
            .add {
                width: 40px;
                height: 40px;
                background: url(../assets/indexb/add.png) no-repeat center center;
                background-size: contain;
                margin: 0 auto;
                margin-top: 10px;
            }
        }
    }
    .page8 {
        z-index: 6;
        .content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: url(../assets/indexb/page6_bg.jpg) no-repeat center center;
            background-size: 100% 100%;
            .gif {
                width: 1260px;
                height: 614px;
                position: absolute;
                left: 331px;
                top: 238px;
                background: url(../assets/gif/gif0.gif);
                background-size: cover;
                z-index: 3;
            }
            .img0 {
                width: 841px;
                height: 292px;
                position: absolute;
                left: 243px;
                top: 145px;
                background: url(../assets/indexb/page8_img0.jpg);
                background-size: cover;
                z-index: 4;
            }
            .img1 {
                width: 498px;
                height: 373px;
                position: absolute;
                left: 1213px;
                top: 290px;
                background: url(../assets/indexb/page8_img1.jpg);
                background-size: cover;
                z-index: 4;
            }
            .img2 {
                width: 476px;
                height: 356px;
                position: absolute;
                left: 128px;
                top: 612px;
                background: url(../assets/indexb/page8_img2.jpg);
                background-size: cover;
                z-index: 4;
            }
            .img3 {
                width: 476px;
                height: 332px;
                position: absolute;
                left: 846px;
                top: 770px;
                background: url(../assets/indexb/page8_img3.jpg);
                background-size: cover;
                z-index: 4;
            }
            .txt {
                width: 927px;
                height: 199px;
                left: 496px;
                top: 50%;
                transform: translateY(-2000px);
                background: url(../assets/indexb/page8_txt.png);
                background-size: cover;
                position: absolute;
                z-index: 10;
            }
        }
    }

    .page9 {
        z-index: 7;
        background-color: #000;
        .content-0 {
            width: 100%;
            height: 58%;
            position: relative;
            left: 0;
            top: 0;
            .bg {
                width: 100%;
                height: 100%;
                background: url(../assets/indexb/page9_bg.jpg) no-repeat left center;
                background-size: cover;
            }
            .con {
                position: absolute;
                left: 130px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 2;
                width: 1109px;
                cursor: pointer;
                .logo {
                    width: 887px;
                    height: 48px;
                    background: url(../assets/indexb/logo4.png) no-repeat left center;
                    background-size: contain;
                }
                .line {
                    width: 100%;
                    height: 2px;
                    background: url(../assets/indexa/page5_line.png) no-repeat left center;
                    background-size: auto 100%;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }
                .h2 {
                    font-size: 64px;
                    line-height: 1;
                    font-family: 'DFPKingGothicGBMedium';
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                   
                    .after {
                        content: ' ';
                        background: url(../assets/indexa/arrow.png) no-repeat right center;
                        background-size: contain;
                        width: 60px;
                        height: 60px;
                        margin-left: 150px;
                    }
                }
                .h5 {
                    margin-top: 20px;
                    font-size: 24px;
                    line-height: 1;
                }
            }
        }
        .content-1 {
            width: 100%;
            height: 42%;
            position: relative;
            left: 0;
            top: 0;
            .con {
                position: absolute;
                left: 0%;
                top: 50%;
                transform: translateX(0%) translateY(-50%);
                z-index: 2;
                width: 100%;
                text-align: center;
                .logo {
                    width: 131px;
                    height: 48px;
                    background: url(../assets/indexa/logo3.png) no-repeat center center;
                    background-size: contain;
                    display: block;
                    margin: 0 auto;
                }
                .txt {
                    margin-top: 45px;
                    font-size: 24px;
                    line-height: 1.3;
                    color: #9d9d9d;
                }
            }
        }
    }

    .swiperbox {
        position: fixed;
        width: 100%;
        height: 100vh;
        left: 0;
        top: 0;
        z-index: 400;
        background-color: #000;
        display: none;
        .close {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 36px;
            top: 50%;
            transform: translateY(-50%);
            background: url(../assets/indexb/close.png) no-repeat center center;
            background-size: contain;
            z-index: 40;
            cursor: pointer;
        }
        &.page4_swiperbox_0 {
            .itembox {
                width: 340px;
                top: 50%;
                transform: translateY(-50%);
                left: 154px;
                z-index: 30;
                position: absolute;
                .item {
                    font-size: 36px;
                    line-height: 43px;
                    height: 45px;
                    padding: 65px 0; 
                    box-sizing: content-box;
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    color: rgba(255, 255, 255, 0.6);
                    &::after {
                        content: ' ';
                        display: block;
                        width: 30px;
                        height: 30px;
                        background: url(../assets/indexb/arrow.png) no-repeat center center;
                        background-size: contain;
                        padding-left: 25px;
                        margin-top: 6px;
                        flex-shrink: 0;
                        display: none;
                    }
                    &.active,
                    &:hover {
                        color: rgba(255, 255, 255, 1);
                        &::after {
                            display: block;
                        }
                    }
                }
            }
            .contentbox {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                .content_0,
                .content_1,
                .content_2 {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                .content_0 {
                    display: none;
                    .bg {
                        background: url(../assets/indexb/page4_swiperbox_0_bg0.jpg) no-repeat center center;
                        background-size: cover;
                    }
                }
                .content_1 {
                    display: block;
                    .bg0 {
                        display: none;
                        background: url(../assets/indexb/page4_swiperbox_0_bg1.jpg) no-repeat center center;
                        background-size: cover;
                    }
                    .bg1 {
                        background: url(../assets/gif/gif1.gif) no-repeat center center;
                        background-size: cover;
                    }
                }
                .content_2 {
                    display: none;
                    .bg {
                        background: url(../assets/indexb/page4_swiperbox_0_bg3.jpg) no-repeat center center;
                        background-size: cover;
                    }
                }
                .arrowbox {
                    position: absolute;
                    right: 130px;
                    bottom: 140px;
                    z-index: 30;
                    width: 160px;
                    height: 56px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .prev {
                        width: 56px;
                        height: 56px;
                        background: url(../assets/indexb/arrow-left.png) no-repeat center center;
                        background-size: contain;
                        cursor: pointer;
                        &.disable {
                            opacity: 0.5;
                        }
                    }
                    .next {
                        width: 56px;
                        height: 56px;
                        background: url(../assets/indexb/arrow-right.png) no-repeat center center;
                        background-size: contain;
                        cursor: pointer;
                        &.disable {
                            opacity: 0.5;
                        }
                    }
                }
                .textbox {
                    position: absolute;
                    left: 465px;
                    bottom: 130px;
                    z-index: 3;
                    .txt0 {
                        font-size: 48px;
                        line-height: 59px;
                        position: relative;
                        &::before {
                            content: ' ';
                            width: 2px;
                            height: 45px;
                            background-color: #e10202;
                            position: absolute;
                            left: -24px;
                            top: 5px;
                            height: 48px;
                        }
                    }
                    .txt1 {
                        margin-top: 20px;
                        font-size: 20px;
                        line-height: 24px;
                    }
                }
            }
        }

        &.page4_swiperbox_1 {
            .contentbox {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 3;
                .content_0,
                .content_1 {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                .content_0 {
                    display: none;
                    background: url(../assets/indexb/page0_bg.jpg) no-repeat center center;
                    background-size: 100% 100%;
                    .imagesbox {
                        width: 1790px;
                        height: 648px;
                        position: absolute;
                        left: 130px;
                        top: 50%;
                        transform: translateY(-50%);
                        overflow: hidden;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        z-index: 4;
                        .item {
                            width: 20%;
                            height: 100%;
                            position: relative;
                            transition: all 0.5s;
                            .img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                            .title {
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-start;
                                position: absolute;
                                left: 37px;
                                bottom: 37px;
                                z-index: 10;
                                opacity: 0;
                                transition: all 0.5s;
                                cursor: pointer;
                                .add {
                                    background: url(../assets/indexb/add.png) no-repeat center center;
                                    background-size: contain;
                                    width: 40px;
                                    height: 40px;
                                    margin-right: 10px;
                                }
                                .txt {
                                    font-size: 32px;
                                    line-height: 38px;
                                    word-break: keep-all;
                                    white-space: nowrap;
                                }
                            }
                            &.active,
                            &:hover {
                                width: 60%;
                                flex-shrink: 0;
                                .title {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
                .content_1 {
                    display: block;
                    z-index: 10;
                    background: url(../assets/indexb/page0_bg.jpg) no-repeat center center;
                    background-size: 100% 100%;
                    .imgbox {
                        width: 1633px;
                        height: 790px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -56%);
                        z-index: 3;
                        .bigimg {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .textbox{
                            position: absolute;
                            left: 80px;
                            bottom: 110px;
                            width: 1000px;
                            z-index: 4;
                            .txt0{
                                font-size: 48px;
                                line-height: 58px;
                                font-family: 'DFPKingGothicGBMedium';
                                word-break: keep-all;
                                white-space: nowrap;
                                opacity: 0;
                            }
                            .txt1{
                                font-size: 20px;
                                line-height: 24px;
                                margin-top: 20px;
                                word-break: keep-all;
                                white-space: nowrap;
                                opacity: 0;
                            }
                        }
                    }
                    .smallbox {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        z-index: 10;
                        height: 47px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        .item {
                            width: 20%;
                            height: 47px;
                            position: relative;
                            left: 0;
                            top: 0;
                            transition: all 0.5s;
                            cursor: pointer;
                            .img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                            &.active,
                            &:hover {
                                width: 34%;
                                height: 250%;
                                top: -150%;
                            }
                        }
                    }
                }
            }
        }

        &.page4_swiperbox_2 {
            .bgbox {
                width: 100%;
                height: 100%;
                overflow: hidden;
                .bg {
                    background: url(../assets/indexb/page4_swiperbox_2_img0.jpg) no-repeat center center;
                    background-size: cover;
                    transform-origin: 80% center;
                }
            }
            .textbox {
                position: absolute;
                left: 164px;
                bottom: 226px;
                z-index: 3;
                .txt0 {
                    font-size: 48px;
                    line-height: 59px;
                }
                .txt1 {
                    margin-top: 20px;
                    font-size: 20px;
                    line-height: 24px;
                }
            }
            .hotpoint {
                width: 40px;
                height: 40px;
                position: absolute;
                right: 461px;
                top: 567px;
                cursor: pointer;
                z-index: 20;
                background: url(../assets/indexb/page4_swiperbox_2_point.png) no-repeat center center;
                background-size: contain;
                animation: hotpoint_anim 1.5s infinite linear;
                @keyframes hotpoint_anim {
                    0% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.2);
                    }
                    100% {
                        transform: scale(1);
                    }
                }
            }
        }
    }

    .test_driver_box {
        width: 100%;
        height: 100%;
        background: #000 url(../assets/indexb/test_driver_box_bg.jpg) no-repeat center center;
        background-size: cover;
        position: fixed;
        z-index: 280;
        left: 0;
        top: 0;
        display: none;
        .yuyue-box {
            width: 100%;
            height: 583px;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 4;
            transform: translateY(-590px);
        }
        .close {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 36px;
            top: 50%;
            transform: translateY(-50%);
            background: url(../assets/indexb/close.png) no-repeat center center;
            background-size: contain;
            z-index: 40;
            cursor: pointer;
        }
    }

    .video-dialkog{
        position: fixed;
        left:0;
        top:0;
        width: 100%;
        height: 100vh;
        z-index: 4000;
        background-color: rgba(0,0,0,0.8);
        display: none;
        .videobox{
            max-width:1200px;
            width: 80%;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
            z-index:2;
            background-color: #000;
            .video{
                width: 100%;
                height: 100%;
                object-fit: contain;
               
            }
            .close{
                cursor: pointer;
                position: absolute;
                right:-70px;
                top:-70px;
                width:60px;
                height: 60px;
                background: url(../assets/indexb/close.png) no-repeat center center;
                background-size: contain;
                z-index: 10;
            }
        }
    }
}
</style>
